<template>
  <div id="Content">
    <v-app id="inspire">
      <v-content>        
        <v-container class="container">         
          <!-- 最新消息 選單才呈現列表-->          
          <v-row v-if="content.power_title == '最新消息'">
        
            <v-col xs="12" sm="12" md="12">               
              <v-card class="mx-auto vcard_bg">            
                <v-card-title>
                  <div class="page_title_news animated fadeInUp delay_1">
                    <h1>
                      {{ content.power_title }}
                    </h1>
                  </div>
                    <div class="newsSearch">                
                </div>
                </v-card-title>

                <v-spacer></v-spacer>   

                  <v-text-field
                    class="xs6 offset-xs-6 sm6 offset-sm-6 offset-md-9 pb-4 pr-10 pl-10 "
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    v-model="search"
                  >
                  </v-text-field>

                <v-data-table
                  :headers="headers"
                  :items="items"
                  :search="search"
                  @click:row="showAlert"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  hide-default-footer
                  @page-count="pageCount = $event"
                  class="elevation-1 animated fadeInUp delay_5"
                >
                  <template #no-data>
                    <v-alert class="mt-2" dense outlined type="info"
                      >目前無資料!</v-alert
                    >
                  </template>
                  <template #no-results>
                    <v-alert class="mt-2" dense outlined type="info"
                      >抱歉! 無資料</v-alert
                    >
                  </template>
                </v-data-table>
                <!-- 分頁 -->
                <div class="text-center pt-5">
                  <v-pagination
                    v-model="page"
                    :length="pageCount"
                  ></v-pagination>
                </div>
                <!-- v-if="!!selected"-若不是沒有選定的值=有值時才顯示 -->
                <w-log v-if="!!selected" v-model="dialog" :item="selected" />
              </v-card>

            </v-col>
          </v-row>
          <v-row v-else-if="content.power_title == '衛教專區'">
            <v-col xs="12" sm="12" md="12">
              <v-card class="mx-auto pb-16 vcard_bg">
                <v-card-title>
                  <div class="page_title_news animated fadeInUp delay_1">
                    <h1>
                      {{ content.power_title }}
                    </h1>
                  </div>
                </v-card-title>
                <v-spacer></v-spacer>
                <v-data-table
                  :headers="Careheaders"
                  :items="Careitems"
                  @click:row="showAlert2"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  hide-default-footer
                  @page-count="pageCount = $event"
                  class="elevation-1 animated fadeInUp delay_5"
                >
                  <template #no-data>
                    <v-alert class="mt-2" dense outlined type="info"
                      >目前無資料!</v-alert
                    >
                  </template>
                </v-data-table>
                <!-- 分頁 -->
                <div class="text-center pt-5">
                  <v-pagination
                    v-model="page"
                    :length="pageCount"
                  ></v-pagination>
                </div>
                <C-log
                  v-if="!!Careselected"
                  v-model="dialog2"
                  :item="Careselected"
                  class="mydialog"
                />
              </v-card>
            </v-col>
          </v-row>

          <!--資源連結-->
          <v-row v-else-if="content.power_title == '資源連結'">
            <v-col md="12">
              <div class="page_title_news animated fadeInUp delay_1">
                <h1>
                  {{ content.power_title }}
                </h1>
              </div>
            </v-col>
            <v-col md="8 offset-2">
              <!-- <v-list class="vcard_bg"> -->
              <v-list-item
                v-for="item in Linkitems"
                :key="item.title"
                :href="item.link_url"
                target="_blank"
                class="link_line"
              >
                <v-list-item-icon>
                  <v-icon class="small">mdi-link-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.link_title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <!-- </v-list>-->
            </v-col>
          </v-row>
          <v-row v-else class="mx-auto">
            <v-col xs="12" sm="12" md="12">
              <v-card class="vcard_bg">
                <v-card-title>
                  <div class="page_title_news animated fadeInUp delay_1">
                    <h1>
                      {{ content.power_title }}
                    </h1>
                  </div>
                </v-card-title>
                <v-spacer></v-spacer>
                <v-card-text>
                  <div
                    class="fck animated fadeInUp delay_2"
                    v-html="content.menusub_content"
                  ></div>
                </v-card-text>
              </v-card>
              <!-- 網頁內容 end -->
            </v-col>
          </v-row> 
               <!-- loading start -->
        <v-overlay v-model="loading" class="text-center">
            <p>讀取中......</p>
            <v-progress-circular size="50" indeterminate />
          </v-overlay> 
          <!-- loading end -->   
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import api from "../utils/apis/DepApi.js";
import "./../assets/css/fck.css";

export default {
  name: "Content",
  components: {
    WLog: () => import("./Child"),
    CLog: () => import("./CarePaper"),
  },

  data: () => ({
    selected: null,
    search: "",
    dialog: false,
    loading: false,
    headers: [
      {
        text: "公告日",
        align: "start",
        sortable: true,
        value: "news_start_date",
        width: "15%",
      },
      {
        text: "標題",
        align: "center",
        sortable: false,
        value: "news_title",
        width: "85%",
      },
    ],
    items: [],
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    Careselected: null,
    dialog2: false,
    Careheaders: [
      {
        text: "標題",
        align: "center",
        sortable: false,
        value: "carepaper_title",
      },
    ],

    Careitems: [],

    Linkheaders: [
      {
        text: "",
        align: "start",
        sortable: false,
        value: "link_title",
      },
    ],
    Linkitems: [],
  }),

  computed: {
    content() {
      return this.$store.state.menuData.find(
        (x) => x.power_id == this.$store.state.menuId
      );
    },
  },

  mounted() {
    this.getData();
    this.getCarePaper();
    this.getLink();
  },

  methods: {
    //最新訊息
    getData() {
      this.loading = true;

      api
        .CtrNews()
        .then((response) => (this.items = response.data.Data))
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
    //選取此row時觸發之事件
    showAlert(e) {
      //if (event.target.classList.contains('btn_content')) return;
      // alert('Alert! \n' + a.news_title);
      this.dialog = true;
      this.selected = e;
    },

    //衛教專區
    getCarePaper() {
      this.loading = true;

      api
        .CtrCarePaper()
        .then((response) => (this.Careitems = response.data.Data))
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
    //選取此row時觸發之事件
    showAlert2(e) {
      this.dialog2 = true;
      this.Careselected = e;
    },

    //資源連結
    getLink() {
      this.loading = true;
      api
        .CtrLink()
        .then((response) => (this.Linkitems = response.data.Data))
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style>
.container {
  font-size: 1rem;
  color: #222 !important;
  width: 100%;
  padding: 15px;
  margin-right: auto;
  margin-left: auto;
  /* background: url('../assets/image/bg2.jpg') left top repeat-x repeat-Y; */
}

.page_title {
  width: 100%;
  font-size: 2rem;
  color: #2c2a2a;
  text-align: right;
  margin-top: 1rem;
  margin-right: 15%;
}
/* 最新消息 */
.page_title_news {
  width: 50%;
  font-size: 2rem;
  color: #333;
  text-align: center;
  margin: 1.25rem auto 0;
}

@media (max-width: 990px) {
  .page_title_news {
    width: 80%;
  }
}
@media (max-width: 640px) {
  .page_title_news {
    width: 100%;
  }
  .page_title_news {
    font-size: 1.5rem;
  }
}

.page_title_news h1 {
  width: 30%;
  margin: 0 auto;
  text-align: center;
}

.page_title_news h1:after {
  content: "";
  display: block;
  border-bottom: 4px solid rgb(253, 142, 124);
  width: 0%;
  height: 2px;
  margin: 10px 0 0;
  background-color: #fd8e7c;
  -webkit-animation-name: h1txt; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 0.3s; /* Safari 4.0 - 8.0 */
  animation-name: h1txt;
  animation-duration: 2s;
  animation-delay: 0.2s;
  animation-fill-mode: both;
}

@keyframes h1txt {
  from {
    width: 10%;
  }
  to {
    width: 100%;
  }
}

/* v-card 框線陰影-無 */
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0) !important;
}

/* 搜尋 */
/* .newsSearch[data-v-7eab81f9] {
  width: 50%;
  margin: 10px auto;
} */
/* @media (max-width: 640px) {
  .newsSearch[data-v-7eab81f9] {
    width: 100% !important;
    margin: 0 auto;
  }
} */

.v-data-table .v-data-table--has-bottom .theme--light {
  font-size: 1rem;
  color: #222;
}

.theme--light.v-table tbody tr:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.elevation-1 {
  font-size: 16px;
  width: 95%;
  margin: 0 auto;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  background-color: #f19e99;
  color: #222;
  font-size: 1.2rem;
  padding-top: 15px;
  text-align: center;
  letter-spacing: 1rem !important;
  border-bottom: 2px solid #6e6666 !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 1rem !important;
  text-align: left !important;
}
.v-data-table > .v-data-table__wrapper > table tr td {
  padding: 12px !important;
  line-height: 3rem;
}
.theme--light.v-divider {
  border-color: #fff !important;
}
.link_line {
  border-bottom: 1px dashed #f19e99;
}

.link_line:hover {
  color: #fff !important;
}
/* .v-overlay__scrim {
  height: 1% !important;
} */
</style>
